import React, { Component } from 'react';
import { VictoryLabel } from 'victory';
import { RELEASES } from './Timeline.helpers';
import { ChartTooltip } from './ChartTooltip';
import { TurbineReleaseTooltipContent } from '../Tooltip/TurbineReleaseTooltipContent';
import { chartTheme } from '../../common/ChartTheme';

const labelStyle = { ...chartTheme.bar.style.labels, pointerEvents: 'none' };

export class ReleaseOffsetLabelWithTooltip extends Component {
    static defaultEvents = ChartTooltip.defaultEvents;

    shouldComponentUpdate(nextProps) {
        return this.props.active !== nextProps.active;
    }

    render() {
        const {
            alignmentOffset,
            y,
            datum: { type, beginDate, endDate },
        } = this.props;

        const offset = type === RELEASES.HV ? -alignmentOffset : alignmentOffset;
        const newY = y + offset;
        const minTimeSpan = 1500000; // 25 minutes
        const barIsWideEnoughForLabel = endDate - beginDate > minTimeSpan;

        return (
            <g>
                {barIsWideEnoughForLabel && <VictoryLabel key="label" {...this.props} style={labelStyle} y={newY} />}
                <ChartTooltip key="tooltip" {...this.props} content={TurbineReleaseTooltipContent} />
            </g>
        );
    }
}
